import React, { useState } from 'react'
import '../css/portfoilo.scss'
import { ReactPopup } from '../components/popup';

function Portfoilo(props : any) {
  
  let portfoilo = [
    { 'react' : [
      { title  : '의류쇼핑몰', desc : ['React를 통해 제작된 프로젝트입니다.'], addr : 'https://96qudgus.github.io/react/', thumb : 'react-shop-thumb.png' },
      { title : '인스타그램', desc : ['React와 Next를 통해 제작될 프로젝트입니다.'], thumb : 'Instagram_logo_2022.svg' }
    ] },
    { 'html' : [
      { title : '삼성 글로벌' , desc : ['Product Detail, Product Showcase 페이지 제작했습니다.', '약 50여개국의 언어 현지화 작업을 진행했습니다.', 'AEM을 통해 제작이 되었습니다.'], addr : 'https://www.samsung.com/uk/smartphones/galaxy-s/', thumb : 'samsung-thumb.png' },
      { title : '안랩', desc : ['서브로 담당한 프로젝트입니다.', '주로 유지, 보수를 담당했습니다.'], addr : 'https://smbplace.ahnlab.com/smb/main.do?cmd=main', thumb : 'ahnlab-thumb.png' }
    ] },
    {
      'wordpress' : [
        { title : 'adik', desc : ['전페이지 제작했습니다.', 'Elementor 플러그인을 사용했습니다.'], addr: 'https://adik.co.kr/', thumb : 'adik-thumb.png' },
        { title : 'cqv', desc : ['전페이지 제작했습니다.', 'Brizy 플러그인을 사용했습니다.'], addr: 'https://cqv.co.kr/', thumb : 'cqv-thumb.png' },
        { title : 'ghostpass', desc : ['뉴스 페이지 제외한 전 페이지를 제작했습니다.', 'Brizy 플러그인을 사용했습니다.'], addr: 'https://www.ghostpass.ai/', thumb : 'ghostpass-thumb.png' },
        { title : 'wonbang', desc : ['영문으로 변환 및 국문페이지 수정을 작업했습니다.', 'Elementor 플러그인을 사용했습니다.'], addr: 'http://wonbangtech.com/home-new-eng/', thumb : 'wonbang-thumb.png' }
      ]
    }
  ]

  // 내용
  const reactDetail = Object.values(portfoilo[0])[0]; // REACT
  const htmlDetail = Object.values(portfoilo[1])[0]; // HTML
  const wpDetail = Object.values(portfoilo[2])[0]; // WORDPRESS
  // 내용 end
  // 팝업 open
  let [popup, setPopup] : boolean | any = useState(false);
  let closePopup = (value : boolean) => { setPopup(value); }
  // 팝업 open end
  // 팝업이 열리면 브라우저의 스크롤 방지
  const bodyWrap = document.querySelector('body');
  if (popup === true) { bodyWrap?.classList.add('scrollX'); } 
  else { bodyWrap?.classList.remove('scrollX'); }
  // 팝업 스크롤 방지 end

  return (
    <section className='portfoilo'>
      <h2>PROTFOILO</h2>
      {/* 메인 프로젝트 */}
      <h4>개인 프로젝트</h4>
      <ul className='mainProject max1600'>
        {
          reactDetail.map((react : any) => {
            return (
              <li>
                {/* 배경 */}
                <div className="backBox"><img src={process.env.PUBLIC_URL + '/assets/img/' + react.thumb} alt={react.thumb} /></div>
                {/* 내용 */}
                <div className='hoverShow'>
                  <div className="titleBox">
                    <h4>{ react.title } 개인 프로젝트</h4>
                    <img src={ process.env.PUBLIC_URL + "/assets/img/React-icon.png" } alt="React Icon" />
                  </div>
                  <ul>
                    { react.desc.map((reactDesc : any) => { return ( <li>{ reactDesc }</li> ) }) }
                  </ul>
                  {
                    react.title === '인스타그램'
                    ? <button>준비중입니다.</button>
                    : (
                      <div className="btnBox">
                        <button onClick={() => { setPopup(true); }}>요약 보기</button>
                        <button onClick={() => { window.open(react.addr, '_blank'); }}>바로 이동</button>
                      </div>
                    )
                  }
                </div>
              </li>
            )
          })
        }
      </ul>
      <br/>
      {/* 서브 프로젝트 */}
      <h4>비스톤스(주) 20.09~21.03</h4>
      <ul className='subProject max1600'>
      {
        // HTML 프로젝트
        htmlDetail.map((html : any) => {
          return (
            <li>
              {/* 배경 */}
              <div className="backBox"><img src={process.env.PUBLIC_URL + '/assets/img/' + html.thumb } alt={html.thumb} /></div>
              {/* 내용 */}
              <div className='hoverShow'>
                <div className="titleBox">
                  <h4>{ html.title } 프로젝트</h4>
                  <img src={ process.env.PUBLIC_URL + "/assets/img/html_logo.png" } alt="HTML Icon" />
                </div>
                <ul>
                  { html.desc.map((htmlDesc: any) => { return ( <li>{htmlDesc}</li> ) }) }
                </ul>
                <button onClick={() => { window.open(html.addr, '_blank'); }}>바로 이동</button>
              </div>
            </li>
          )
        })
      }
      </ul>
      <br/>
      <h4>리사컴퍼니 21.12~22.06</h4>
      <ul className='subProject max1600'>
      {
        // Wordpress 프로젝트
        wpDetail.map((wp : any) => {
          return (
            <li>
              {/* 배경 */}
              <div className="backBox"><img src={process.env.PUBLIC_URL + '/assets/img/' + wp.thumb } alt={wp.thumb} /></div>
              {/* 내용 */}
              <div className='hoverShow'>
                <div className="titleBox">
                  <h4>{ wp.title.toUpperCase() } 프로젝트</h4>
                  <img src={ process.env.PUBLIC_URL + "/assets/img/wordpress.png" } alt="Wordpress Icon" />
                </div>
                <ul>
                  { wp.desc.map((wpDesc: any) => { return ( <li>{wpDesc}</li> ) }) }
                </ul>
                <button onClick={() => { window.open(wp.addr, '_blank'); }}>바로 이동</button>
              </div>
            </li>
          )
        })
      }
      </ul>
      { popup === true ? <ReactPopup closePopup = { closePopup }/> : null }
    </section>
  )
}

export default Portfoilo;